import React, { useContext, useState, useEffect } from "react";
import {
  ChevronRight,
  SettingsAdjust,
  Launch,
  Add,
  Grid,
  List,
  Chat,
  FilterReset,
} from "@carbon/icons-react";
import { Link } from "react-router-dom";
import {
  Button,
  Tabs,
  Tab,
  ButtonSet,
  DatePickerInput,
  DatePicker,
  SelectItem,
  Select,
  Form,
  Search,
} from "@carbon/react";
import GridModeTab from "./SupportTab/GridModeTab";
import ListViewTab from "./SupportTab/ListViewTab";
import { GlobalContext } from "../../ContextApi/GlobalContext";
import { Contextprovider } from "../../App";

export const SupportServiceCard = ({
  id,
  servicename,
  serviceabout,
  created,
  onClick,
}) => (
  <Link to={`/ticketdetail/` + id} onClick={onClick}>
    <div className="inside-box">
      <div className="support-inside-box-title">
        <h4>
          #{id} | {servicename}
        </h4>
        <Launch fill="#fff" />
      </div>
      <h3>{serviceabout}</h3>
      <div className="bx--row ">
        <div className="circle-SV">
          <h5>SV</h5>
        </div>
        <div className="bx--col" style={{ paddingRight: "4rem" }}>
          <p>{created}</p>
        </div>
      </div>
    </div>
  </Link>
);

const formatCount = (count) =>
  Number(count) < 10 ? `0${count}` : count;

const getDesktopFilterStyle = (show, listActive) => ({
  border: show === false ? "2px solid #0f62fe" : "",
  pointerEvents: listActive ? "none" : "",
});

const getMobileFilterStyle = (show, listActive) => ({
  borderBottom: show === false ? "1.5px solid #0f62fe" : "",
  pointerEvents: listActive ? "none" : "",
});

const SupportCenter = () => {
  const { toggle, settoggle } = useContext(GlobalContext);
  const { useralldata, dispatch } = useContext(Contextprovider);

  function setTicketFilter(activeKey) {
    settoggle({
      openShow: activeKey !== "openShow",
      closedShow: activeKey !== "closedShow",
      pendingShow: activeKey !== "pendingShow",
      newShow: activeKey !== "newShow",
      ...(activeKey === "openShow" && { applyFilter: true }),
    });
  }

  function openticket() { setTicketFilter("openShow"); }
  function closedticket() { setTicketFilter("closedShow"); }
  function pendingticket() { setTicketFilter("pendingShow"); }
  function newticket() { setTicketFilter("newShow"); }

  function initializeFilters() {
    if (window.innerWidth < 900) {
      settoggle({ openShow: false, closedShow: true, pendingShow: true, newShow: true });
    }
  }

  const Show = () => {
    settoggle({ ...toggle, FillterToggle: !toggle.FillterToggle });
  };

  const ResetFilter = () => {
    settoggle({ ...toggle, FillterToggle: !toggle.FillterToggle });
    dispatch({
      type: "FILLTER_DATA",
      payload: { applyFilter: false, startDate: "", endDate: "" },
    });
  };

  const Setfilter = () => {
    dispatch({ type: "FILLTER_DATA", payload: { applyFilter: true } });
    settoggle({ ...toggle, FillterToggle: !toggle.FillterToggle });
  };

  const noActiveFilters =
    !toggle.openShow && !toggle.closedShow && !toggle.pendingShow && !toggle.newShow;

  const [loading, setloading] = useState(false);

  useEffect(() => {
    initializeFilters();
  }, []);

  return (
    <>
      {window.scrollTo(0, 0)}
      <div className="bx--grid--full-width TicketInfo">
        <div className="bx--grid bx--no-gutter allticket-page">
          <div className="">
            <div className="bx--row bx--row-padding">
              <div className="bx--col allticket-info">
                <h3>Welcome to</h3>
                <h1>
                  All Tickets
                  <span className="alltickets_svg">
                    <ChevronRight />
                  </span>
                  <Link to="/">Home</Link>
                </h1>
                {/* {toggle.openShow ||
toggle.closedShow ||
toggle.pendingShow ||
toggle.newShow ||
Fillter.applyFilter == true ? (
<div className='fillterbtn'>
<Button
kind='ghost'
size='sm'
onClick={() => {
settoggle({
...toggle,
openShow: '',
closedShow: '',
pendingShow: '',
newShow: '',
});

setFillter({
...Fillter,
applyFilter: false,
startDate: '',
endDate: '',
});
}}
>
Clear Fillter
</Button>
</div>
) : (
''
)} */}
              </div>
            </div>

            <div className="support-filter-section">
              <div className="bx--row">
                <div className="filter-add">
                  <ButtonSet>
                    <Button
                      hasIconOnly
                      kind="secondary"
                      tooltipPosition="bottom"
                      renderIcon={SettingsAdjust}
                      iconDescription="Filter"
                      onClick={Show}
                    />
                    <Button
                      onClick={() =>
                        settoggle({
                          ...toggle,
                          Support: !toggle.Support,
                          tabselect: 0,
                        })
                      }
                      hasIconOnly
                      kind="primary"
                      tooltipPosition="bottom"
                      renderIcon={Add}
                      iconDescription="Add new"
                    />
                  </ButtonSet>
                </div>
                <div className="filterBlock summer">
                  <div
                    className="bx--col section-column"
                    onClick={openticket}
                    style={getDesktopFilterStyle(toggle.openShow, toggle.ListActive)}
                  >
                    <p>OPEN</p>
                    <h2>{formatCount(useralldata?.GlobalState.newCount)}</h2>
                  </div>
                  <div
                    className="bx--col section-column"
                    onClick={newticket}
                    style={getDesktopFilterStyle(toggle.newShow, toggle.ListActive)}
                  >
                    <p>ASSIGNED</p>
                    <h2>{formatCount(useralldata?.GlobalState.openCount)}</h2>
                  </div>
                  <div
                    className="bx--col section-column"
                    onClick={pendingticket}
                    style={getDesktopFilterStyle(toggle.pendingShow, toggle.ListActive)}
                  >
                    <p>IN PROGRESS</p>
                    <h2>{formatCount(useralldata?.GlobalState.pendingCount)}</h2>
                  </div>

                  <div
                    className="bx--col section-column"
                    onClick={closedticket}
                    style={getDesktopFilterStyle(toggle.closedShow, toggle.ListActive)}
                  >
                    <p>CLOSED</p>
                    <h2>{formatCount(useralldata?.GlobalState.closedCount)}</h2>
                  </div>
                </div>
              </div>
              <div className="mobFilterBlock">
                <div className="filters">
                  <div
                    className="bx--col-sm-1 section-column"
                    onClick={openticket}
                    style={getMobileFilterStyle(toggle.openShow, toggle.ListActive)}
                  >
                    <p>OPEN</p>
                    <h2>{formatCount(useralldata?.GlobalState.newCount)}</h2>
                  </div>
                  <div
                    className="bx--col-sm-1 section-column"
                    onClick={pendingticket}
                    style={getMobileFilterStyle(toggle.pendingShow, toggle.ListActive)}
                  >
                    <p>IN PROGRESS</p>
                    <h2>{formatCount(useralldata?.GlobalState.pendingCount)}</h2>
                  </div>
                  <div
                    className="bx--col-sm-1 section-column"
                    onClick={newticket}
                    style={getMobileFilterStyle(toggle.newShow, toggle.ListActive)}
                  >
                    <p>ASSIGNED</p>
                    <h2>{formatCount(useralldata?.GlobalState.newCount)}</h2>
                  </div>
                  <div
                    className="bx--col-sm-1 section-column"
                    onClick={closedticket}
                    style={getMobileFilterStyle(toggle.closedShow, toggle.ListActive)}
                  >
                    <p>CLOSED</p>
                    <h2>{formatCount(useralldata?.GlobalState.closedCount)}</h2>
                  </div>
                </div>
              </div>

              <div>
                {toggle.FillterToggle ? (
                  <Form className="form">
                    <div style={{ padding: "1rem" }}>
                      <Select
                        defaultValue="placeholder-item"
                        id="select-1"
                        invalidText="This is an invalid error message."
                        labelText="Support type"
                      >
                        <SelectItem
                          text="Technical Service Request"
                          value="option-1"
                        />
                        <SelectItem
                          text="Customer Service Request"
                          value="option-2"
                        />
                      </Select>
                    </div>
                    <div style={{ marginBottom: "2rem", padding: "0 1rem" }}>
                      <DatePicker
                        dateFormat="m/d/Y"
                        datePickerType="single"
                        onInput={(e) =>
                          dispatch({
                            type: "FILLTER_DATA",
                            payload: {
                              ...useralldata?.Fillter,
                              startDate: e.target.value,
                            },
                          })
                        }
                      >
                        <DatePickerInput
                          id="date-picker-default-id"
                          placeholder="mm/dd/yyyy"
                          labelText="Start date"
                          value={useralldata?.Fillter.startDate}
                          type="text"
                        />
                      </DatePicker>
                      <DatePicker
                        dateFormat="m/d/Y"
                        datePickerType="single"
                        onInput={(e) =>
                          dispatch({
                            type: "FILLTER_DATA",
                            payload: {
                              ...useralldata?.Fillter,
                              endDate: e.target.value,
                            },
                          })
                        }
                      >
                        <DatePickerInput
                          id="date-picker-default-id2"
                          placeholder="mm/dd/yyyy"
                          labelText="End date"
                          value={useralldata?.Fillter.endDate}
                          type="text"
                        />
                      </DatePicker>
                    </div>
                    <ButtonSet>
                      <Button kind="secondary" onClick={ResetFilter}>
                        Reset filters
                      </Button>
                      <Button kind="primary" onClick={Setfilter}>
                        Apply filters
                      </Button>
                    </ButtonSet>
                  </Form>
                ) : null}
              </div>
              <div className="bx--row bx--no-gutter">
                <div className="bx--col">
                  <Search
                    labelText=""
                    light
                    placeHolderText="Search ticket by keyword or ID"
                    onChange={(e) =>
                      dispatch({
                        type: "FILLTER_DATA",
                        payload: {
                          ...useralldata?.Fillter,
                          search: e.target.value,
                        },
                      })
                    }
                  />
                </div>
                {!toggle.ListActive ? (
                  <div>
                    <Button
                      type="reset"
                      disabled={noActiveFilters}
                      onClick={() => {
                        settoggle({
                          ...toggle,
                          openShow: "",
                          closedShow: "",
                          pendingShow: "",
                          newShow: "",
                        });
                        dispatch({
                          type: "FILLTER_DATA",
                          payload: {
                            ...useralldata?.Fillter,
                            applyFilter: false,
                            startDate: "",
                            endDate: "",
                          },
                        });
                      }}
                      renderIcon={FilterReset}
                    >
                      Reset filters
                    </Button>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="bx--row">
                <Tabs light selectionMode="manual" className="hed">
                  <Tab
                    label={<Grid />}
                    onClick={() => settoggle({ ...toggle, ListActive: false })}
                  >
                    <div className="support-grid-page">
                      <GridModeTab />
                    </div>
                  </Tab>
                  <Tab
                    label={<List />}
                    onClick={() =>
                      settoggle({
                        ...toggle,
                        openShow: "",
                        closedShow: "",
                        newShow: "",
                        pendingShow: "",
                        ListActive: true,
                      })
                    }
                  >
                    <div className="support-list-page">
                      <ListViewTab />
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
            <div
              className="chat-bot-icon"
              onClick={() =>
                settoggle({
                  ...toggle,
                  Support: !toggle.Support,
                  tabselect: 1,
                })
              }
            >
              <Chat />
            </div>
            <div
              className="chat-bot-icon2"
              onClick={() =>
                settoggle({
                  ...toggle,
                  Support: !toggle.Support,
                  tabselect: 1,
                })
              }
            >
              <Chat />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SupportCenter;
